import { render, staticRenderFns } from "./Sentiers.vue?vue&type=template&id=d732e25e&scoped=true&"
import script from "./Sentiers.vue?vue&type=script&lang=js&"
export * from "./Sentiers.vue?vue&type=script&lang=js&"
import style0 from "./Sentiers.vue?vue&type=style&index=0&id=d732e25e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d732e25e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
